module.exports = __webpack_public_path__ + "6e35d53899b5a1260f946a00b691e0b7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/france.png
 ** module id = 654
 ** module chunks = 0
 **/